export const sp_leadDetails = {
  heading1: 'Detalles de plomo',
  heading2: 'Notas de plomo',
  heading3: 'DocuSign',
  heading4: 'Programación de citas',
  leadTooltip: 'El portal muestra hasta 6 meses de datos',
  name: {
    label: 'Nombre',
    info: 'El nombre del cliente.'
  },
  phoneNo: {
    label: 'Telefono no',
    info: 'El número de teléfono del cliente.'
  },
  email: {
    label: 'Correo electrónico',
    info: 'La dirección de correo electrónico del cliente.'
  },
  createdOn: {
    label: 'Creado en',
    info: 'Cuando el plomo se creó en nuestro sistema.'
  },
  leadType: {
    label: 'Tipos de plomo',
    info: 'El tipo de plomo classifed por el usuario manejar el chat.'
  },
  initiatedBy: {
    label: 'Iniciado por',
    info: 'Cuando el chat se inició desde.'
  },
  username: {
    label: 'Enviado por'
    //info: 'Where the chat was started from.'
  },
  notificationState: {
    label: 'Estado'
    //info: 'Where the chat was started from.'
  },
  sentBy: {
    label: 'Sent By'
    //info: 'Where the chat was started from.'
  },
  appointmentStartTime: {
    label: 'Hora de inicio'
    //info: 'Where the chat was started from.'
  },
  appointmentEndTime: {
    label: 'Hora de finalización'
    // info: 'Where the chat was started from.'
  },
  appointmentStatus: {
    label: 'Estado de la cita'
    //info: 'Where the chat was started from.'
  },
  documentVerified: {
    label: 'Documento Verificado'
    //info: 'Where the chat was started from.'
  },
  docuSignNotificationState: {
    label: 'Estado del documento de DocuSign'
    //info: 'Where the chat was started from.'
  },
  called: {
    label: 'Llamada',
    info: 'El usuario intenta conectarse al visitante y de negocios.'
  },
  attemptedCalls: {
    label: 'Los intentos de llamadas',
    info: 'Número de intentos de conexión de llamada.'
  },
  completedCalls: {
    label: 'Llamadas completadas',
    info: 'Número de llamada completada intentos de conexión.'
  },
  keywords: {
    label: 'Palabras clave',
    info: 'Proporcionar las palabras clave si el sistema fue capaz de capturarlo.'
  },
  flagAsProcessed: {
    label: 'Marcar como procesa',
    info: 'Marcar como procesa'
  },
  flagAsUnProcessed: {
    label: 'Marcar como no procesada',
    info: 'Marcar como no procesada'
  },
  forwardLead: {
    label: 'delantera',
    info: 'delantera'
  },
  replyToVisitor: {
    label: 'Responder a los visitantes',
    info: 'Responder a los visitantes'
  },
  viewChat: {
    label: 'Ver conversación',
    info: 'Ver conversación'
  },
  viewCompany: {
    label: 'Ver empresa',
    info: 'Ver empresa'
  },
  region: { label: 'Región', info: 'Región' },
  leadCategory: { label: 'Categoría de plomo', info: 'Categoría de plomo' },
  appliedRule: { label: 'regla aplicada', info: 'regla aplicada' },
  forwardLeadModal: {
    title: 'delantera',
    email_label: 'Dirección de correo electrónico',
    email_placeholder: 'Ingrese correo electrónico',
    email_info:
      'Presiona enter para agregar la dirección de correo electrónico.',
    note_label: 'Notas adicionales',
    note_placeholder: 'Escribe una nota',
    saveBtn: 'Ahorrar',
    sendBtn: 'enviar',
    closeBtn: 'Cerca'
  }
};
export default sp_leadDetails;
